import IconButton from "@mui/material/IconButton";
import InformationIcon from "@mui/icons-material/InfoOutlined";

interface CustomInformationButtonProps {
  color?: string;
  size?: string;
  containerSize?: string;
  disableHover?: boolean;
}

function CustomInformationButton({
  color = "info.main",
  size = "16px",
  containerSize,
  disableHover = false,
}: CustomInformationButtonProps): JSX.Element {
  const iconStyle = { fontSize: size };
  const buttonStyle = {
    color,
    width: containerSize,
    height: containerSize,
    padding: 0,
    ...(disableHover && {
      "&:hover": {
        backgroundColor: "transparent",
      },
    }),
  };

  return (
    <IconButton sx={buttonStyle}>
      <InformationIcon style={iconStyle} />
    </IconButton>
  );
}

export default CustomInformationButton;
